import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router/index.js';
import { initPageMeta } from './composables/usePageMeta.js';
import './styles/base.css';

const app = createApp(App);
app.use(router);
initPageMeta(router);
app.mount('#app');
